import PaintLogisticsWorkspace from '../../placeholders/PaintLogisticsWorkspace';

export default PaintLogisticsWorkspace;
